import { useTransactionInitiate } from "Hooks/useTransactionInitiate";
import { useState } from "react";
import {
  type ErrorType,
  getIsPaypointTransactionConflict,
} from "Utils/TransactionErrorsUtils";
import type { InitiateTransactionRequest } from "Infrastructure/Api/Api";

type Props = {
  onError?: (error: ErrorType, transaction: InitiateTransactionRequest) => void;
};

type Result = {
  initiateTransaction: (transaction: InitiateTransactionRequest) => void;
  isPending: boolean;
  conflictingTransaction: InitiateTransactionRequest | null;
  resetConflictingTransaction: () => void;
};

export const useInitiatePaypointPayment = ({ onError }: Props): Result => {
  const [conflictingTransaction, setConflictingTransaction] =
    useState<InitiateTransactionRequest | null>(null);

  const { mutate: initiateTransaction, isPending } = useTransactionInitiate({
    onError: (error: ErrorType, transaction) => {
      if (getIsPaypointTransactionConflict(error)) {
        return setConflictingTransaction(transaction);
      }
      onError?.(error, transaction);
    },
  });

  return {
    initiateTransaction,
    isPending,
    conflictingTransaction,
    resetConflictingTransaction: () => setConflictingTransaction(null),
  };
};
